import {gql} from '@apollo/client'

export default gql`
mutation AddUser($user_name: String, $password: String, $role: String, $survey_language: String, $trial_type: String) {
  addUser(user_name: $user_name, password: $password, role: $role, survey_language: $survey_language, trial_type: $trial_type) {
    id
    user_name
  }
}
`